import { z } from 'zod';
import { positionSchema } from './positionSchema';
import { productsSchema } from './products';
import { reactionLineSchema } from './reactionLineSchema';
import { referenceSchema } from './referenceSchema';

export const reactionSchema = z.object({
  centerPoint: positionSchema,
  hierarchyVisibilityLevel: z.string().nullable(),
  id: z.number(),
  kineticLaw: z.null(),
  lines: z.array(reactionLineSchema),
  modelId: z.number(),
  modifiers: z.array(productsSchema),
  name: z.string(),
  notes: z.string(),
  products: z.array(productsSchema),
  reactants: z.array(productsSchema),
  reactionId: z.string(),
  references: z.array(referenceSchema),
  type: z.string(),
});
